import { africanTechInnovation } from './blog-posts/african-tech-innovation';
import { digitalMarketingAfrica } from './blog-posts/digital-marketing-africa';
import { reelsVsTiktok } from './blog-posts/reels-vs-tiktok';

export const blogPosts = [
  africanTechInnovation,
  digitalMarketingAfrica,
  reelsVsTiktok
];

export const getFormattedContent = (content) => {
  return content.split('\n\n').map(paragraph => paragraph.trim()).filter(Boolean);
}; 